export default __webpack_public_path__ + "file-asset/2efa9636c84eab4ff8c698fed3d74ed3-residents_sample.csv";